<template>
  <div class="header">
    <van-config-provider theme="dark" style="width: 100%;">
      <template v-if="isLargeScreen === true">
        <img class="bg-1"
          src="https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/7ae0b82d-f6fc-4ce5-b793-3d97fc3d29ce.png" />
      </template>
      <template v-else>
        <img class="bg-1" src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/bgmo.png" />
      </template>
      <BackgroundVideo style="position: absolute; top: 0; left: 0" />
      <div class="author">创意作品来自<br v-if="isLargeScreen === false" />@野菩萨</div>
      <div style="
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.2);
      "></div>
      <div v-if="isLargeScreen === false" class="hair">
        <van-nav-bar :left-arrow="(isKyMobile || isKs) === true" :border="false" @click-left="goBack">
          <template #right>
            <div class="right-text" @click="emit('toRule')">规则</div>
            <div class="right-text header-share-btn" @click="handleShare">
              分享
            </div>
          </template>
        </van-nav-bar>
      </div>
      <div class="box">
        <div class="neck">
          <img v-if="isLargeScreen === true" class="logo"
            src="https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/095d6082-100d-4d57-bf16-acd5edf4f6ac.png" />
          <img v-else class="logo" src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/title.png" />
        </div>
        <div class="btn-group" v-if="isStaging2 !== true">
          <Button class="btn-left" type="first-screen" size="large" @click="handleCreate"></Button>
          <Button type="primary" size="large" @click="handleContribute">立即投稿</Button>
        </div>
        <div v-else class="btn-group">
          <img v-if="isLargeScreen === false" style="height: .6rem;"
            :src="isStaging3
              ? 'https://p4-ky.wsukwai.com/kos/nlav12119/bSIBDAaa_2024-08-15-11-24-43.png'
              : 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/43323bb2-9882-4efe-8490-235fbec22cf3.png'" />
          <img v-else style="height: 1.48rem;" :src="isStaging3
            ? 'https://p4-ky.wsukwai.com/kos/nlav12119/XFjZuejY_2024-08-15-11-23-54.png'
            : 'https://p4-ky.wsukwai.com/kos/nlav12119/wkhiBiCv_2024-08-07-20-10-54.png'" />
        </div>
        <template v-if="isLargeScreen === false">
          <img class="bottom-logo-mobile" src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/logo.png" />
        </template>
      </div>
      <van-share-sheet v-model:show="showShare" title="分享到" :options="options" @select="handleShareSelect"
        class="share-sheet" />
    </van-config-provider>
  </div>
</template>
<script setup lang="ts">
import { NavBar as VanNavBar, showToast, ShareSheet as VanShareSheet, ShareSheetOption, ConfigProvider as VanConfigProvider } from "vant";
import { ApiModal } from "../../composables/apiModal";
import Button from "./common/button.vue";
import useDevice from "./common/useDevice";
import RaceModal from "./modal/raceModal.vue";
import CreateModal from "./modal/createModal.vue";
import { checkAuth, checkMobile } from "./checkPermission";
import BackgroundVideo from "./backgroundVideo.vue";
import ClipboardJS from "clipboard";
import kylogger from "@ky/sdk/dist/log/kylogger";
import close from "@ky/sdk/dist/close";
import open from "@ky/sdk/dist/open";

const raceModal = ref<ApiModal<any>>();
const createModal = ref<ApiModal<typeof CreateModal>>();

defineProps<{ isStaging2?: boolean, isStaging3?: boolean }>()

const { isMobile, isKyMobile, isKs, isIOS, isAndroid } = useDevice();
const emit = defineEmits(["toRule"]);
const goBack = () => {
  if (isKyMobile.value) close();
  else {
    window.history.back();
  }
};


const paddingTop = (isKyMobile.value || isKs.value) ? "0.88rem" : "0";
const handleCreate = async () => {
  kylogger.collect("CLICK", "CREATE_NOW", {});
  await checkMobile();
  if (isKyMobile.value) {
    open(
      `kwaiying://krn?bundleId=KyAIAggregation&componentName=AiHomeDetail&featureCode=aiGenVideo&toHotTop=0`,
    );
  } else if (isMobile.value) {
    open(
      `kwaiying://web?url=${encodeURIComponent(
        window.location.href?.replace('full=1', ''),
      )}&showTopBar=false`,
    );
  } else {
    if (!createModal.value) {
      createModal.value = new ApiModal(CreateModal);
    }
    createModal.value.show();
  }
};

const isLargeScreen = ref(false);
const resize = () => {
  isLargeScreen.value = window.innerWidth >= 1360;
};
onMounted(() => {
  resize();
});
window.addEventListener("resize", resize);
window.addEventListener("orientationchange", resize);

onBeforeUnmount(() => {
  window.removeEventListener("resize", resize);
  window.removeEventListener("orientationchange", resize);
})

const handleContribute = async () => {
  kylogger.collect("CLICK", "SUBMIT_NOW", {});

  await checkAuth();
  if (!raceModal.value) {
    raceModal.value = new ApiModal(RaceModal);
  }
  raceModal.value.show();
};

const showShare = ref(false);
type SharePlatform = Extract<Parameters<KwaiYingBridge['shareKwai']>[0], Record<string, any>>['sharePlatform'];
const options: ({ key?: SharePlatform | 'link' } & ShareSheetOption)[][] = [
  ([
    { key: 'wx', name: '微信', icon: 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/0a000159-f6c8-48d0-b0d3-63f851ffa6d4.png' },
    { key: 'pyq', name: '朋友圈', icon: 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/d8a982f7-e6c1-48a4-9a7e-615e08d5caa0.png' },
    // { key: 'weibo', name: '微博', icon: 'weibo' }, // 微博打开快影有问题，先禁用
    isAndroid.value && { key: 'qq', name: 'QQ', icon: 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/8c9d60e5-46af-45c4-9fda-beee3418f06c.png' },
    isAndroid.value && { key: 'qzone', name: 'QQ空间', icon: 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/413be660-09aa-4b80-b7b9-c0e0823caca1.png' },
    { key: 'link', name: '复制链接', icon: 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/b9f796e7-7934-4962-a613-809ea6f08b82.png', className: 'bottom-share-link' },
  ] as ({ key?: SharePlatform | 'link' } & ShareSheetOption)[]).filter(Boolean),
];
const handleShareSelect = (option: typeof options[number][number]) => {
  if (option?.key === 'link') {
    const clipboard = new ClipboardJS(".bottom-share-link", {
      text: () => window.location.href,
    });
    clipboard.on("success", () => {
      showToast({
        message: '<div style="justify-content: center; padding:0.22rem 0.4rem;color:rgba(255,255,255,0.9);font-size: 0.26rem; border-width:0.5px; border-style: solid; border-color: rgba(255,255,255,0.08);background-color: rgba(34,34,34,0.95);border-radius: 16rem;">复制链接成功，去分享~</div>',
        type: 'html'  //所加样式名
      });
    });
    clipboard.on("error", () => {
      // showToast("复制失败，请重试");
      showToast({
        message: '<div style="justify-content: center; padding:0.22rem 0.4rem;color:rgba(255,255,255,0.9);font-size: 0.26rem; border-width:0.5px; border-style: solid; border-color: rgba(255,255,255,0.08);background-color: rgba(34,34,34,0.95);border-radius: 16rem;">复制失败，请重试</div>',
        type: 'html'  //所加样式名
      });
    });
  } else {
    const href = window.location.href;
    const param = {
      shareUItype: 1,
      shareType: 2,
      shareMsg: {
        file_url: `https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/e4f801a8-1590-4528-b94f-9046158ce38b.png`,
        web_url: href,
        title: "可灵AI X 快影视频创作大赛",
        content: `超30万元奖金池，可同时参与多赛道，累计获奖名额300+`
      },
      sharePlatform: option?.key,
      shareTopic: '#可灵AI'
    } as Parameters<KwaiYingBridge['shareKwai']>[0];
    window?.kwaiying?.shareKwai?.(JSON.stringify(param));
  }
  showShare.value = false;
  return;
}


const handleShare = () => {
  kylogger.collect("CLICK", "SHARE", {});
  const href = window.location.href;
  // if (isKyMobile.value) {
  //   showShare.value = true;
  //   return;
  // }
  const clipboard = new ClipboardJS(".header-share-btn", {
    text: () => window.location.href,
  });
  clipboard.on("success", () => {
    showToast({
      message: '<div style="justify-content: center; padding:0.22rem 0.4rem;color:rgba(255,255,255,0.9);font-size: 0.26rem; border-width:0.5px; border-style: solid; border-color: rgba(255,255,255,0.08);background-color: rgba(34,34,34,0.95);border-radius: 16rem;">复制链接成功，去分享~</div>',
      type: 'html'  //所加样式名
    });
  });
  clipboard.on("error", () => {
    // showToast("复制失败，请重试");
    showToast({
      message: '<div style=" justify-content: center; padding:0.22rem 0.4rem;color:rgba(255,255,255,0.9);font-size: 0.26rem; border-width:0.5px; border-style: solid; border-color: rgba(255,255,255,0.08);background-color: rgba(34,34,34,0.95);border-radius: 16rem;">复制失败，请重试</div>',
      type: 'html'  //所加样式名
    });
  });
};
</script>

<style scoped lang="less">
.header {
  width: 100%;
  // height: 26.08rem;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;

  .author {
    position: absolute;
    top: 0;
    right: 0;
    padding: .8rem;
    z-index: 100;
    font-size: .28rem;
    font-weight: 400;
    line-height: .4rem;
    color: rgba(255, 255, 255, 0.5);

    @media screen and (max-width:1360px) {
      line-height: .24rem;
      font-size: .18rem;
      top: 5rem;
      padding: 0 .16rem;
      text-align: end;
    }
  }

  .bg-1 {
    width: 100%;
    position: relative;
    // left: 0;
    // top: 0;
    z-index: 99;

    @media screen and (max-width: 1360px) {
      height: 9rem;
      // background-color: #fff;
    }
  }

  .toast {}

  .hair {
    display: none;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 110;

    @media screen and (max-width: 1360px) {
      display: block;

      :deep(.van-nav-bar) {
        background: transparent;
        z-index: 99;
        padding-top: v-bind(paddingTop);

        &__content {
          background: transparent;
          height: 0.88rem;
        }

        &__left {
          position: relative;
          height: 100%;
          padding: 0;
          margin: 0 0.46rem;

          .van-icon {
            color: #fff;
          }
        }

        &__arrow {
          font-size: 0.4rem;
          margin-right: 0;
        }

        &__right {
          padding: 0 0.24rem;
          display: flex;
          flex-direction: column;
          margin-top: 0.12rem;
          opacity: 1;
          transition: all .1s ease-in-out;
        }

        .right-text {
          color: #fff;
          font-size: 0.2rem;
          font-weight: 600;
          line-height: 0.28rem;
          min-height: 0.64rem;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 0.16rem;
          border: 0.5px solid rgba(255, 255, 255, 0.08);
          border-radius: 50%;
          width: 0.64rem;
          height: 0.64rem;
          background-color: rgba(20, 20, 20, 0.3);
          opacity: 1;
          transition: all .1s ease-in-out;

          &:active {
            opacity: 0.5;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1360px) {
    height: auto;
    background-position: 50% 0;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    z-index: 100;

    .btn-group {
      margin-top: 1.28rem;
      display: flex;
      justify-content: center;
      align-items: center;

      @media screen and (max-width: 1360px) {
        margin-top: 0.5rem;
      }

      .btn-left {
        margin-right: 0.56rem;

        @media screen and (max-width: 1360px) {
          margin-right: 0.24rem;
        }
      }
    }

    .neck {
      margin-top: 5.82rem;
      justify-self: flex-start;
      display: flex;
      justify-content: center;
      align-items: center;

      @media screen and (max-width:1360px) {
        margin-top: 2.04rem;
      }
    }

    .title {
      font-size: 2.12rem;

      @media screen and(max-width: 1180px) {
        font-size: 0.9668rem;
      }
    }

    .subtitle {
      @media screen and(max-width: 1180px) {
        font-size: 0.34rem;
      }
    }
  }

  .logo {
    width: 11.49rem;

    @media screen and (max-width: 1360px) {
      width: 4.4rem;
    }
  }

  .bottom-logo {
    width: 18.28rem;
    position: absolute;
    margin-top: 100vh;

    &-mobile {
      width: 5.4rem;

      @media screen and (max-width: 1360px) {
        margin-top: 2.26rem;
      }
    }
  }

  :deep(.share-sheet) {
    color: rgba(255, 255, 255, 0.9);

    .van-share-sheet__options {
      justify-content: center;
      align-items: center;
      padding-left: 0.1rem;
      padding-right: 0.1rem;
      // background-color: #fff;;
    }

    .van-share-sheet__option {
      height: 1.4rem;
      width: 1.4rem;
      // background-color: #222;
    }

    .van-share-sheet__cancel::before {
      background-color: rgb(20, 23, 26);
    }
  }
}
</style>
